export default "Please wait while we're verifying your email."